import React, { createContext, useContext } from 'react';
import { ILogger } from './interface';
import { getLogger } from './logger';

interface LoggerContextType {
  logger: ILogger;
}

const LoggerContext = createContext({
  logger: getLogger(),
});

export const LoggerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const logger = getLogger();

  return <LoggerContext.Provider value={{ logger }}>{children}</LoggerContext.Provider>;
};

export const useLogger = (): LoggerContextType => {
  const context = useContext(LoggerContext);

  if (!context) {
    throw new Error('useLogger must be used within a LoggerProvider');
  }

  return {
    logger: context.logger,
  };
};
